// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__HmZRW","buttons":"RemoveExpirationActionButtons_buttons__10_J6"};